<template>
<div>
  <h2>Dashboard</h2>
    <div id="videoList">
              <div class="card" style="">
                <div class="card-body">
                    <h6 class="card-subtitle mb-2 text-muted">Choose video:</h6>
              <div>
                <b-button-group vertical>
                  <b-button v-for="video in videos" :key="video.id" @click="setVideoId(video.id, video.video_title)">{{video.video_title}}</b-button>
                </b-button-group>
              </div>
                    <hr>
                        <b-form inline>
                          <b-input v-model="video_input" id="video" type="text"/>
                          <b-button variant="success" @click="addVideo()" >Add Video</b-button>
                      </b-form>
                </div>
            </div>
  <ci-list ref="cilist" v-if="this.$root.globalStore.currentVidId != null" @video-deleted="getVideos()"></ci-list>
</div>
</div>
</template>

<script>
import axios from 'axios'
import {store} from '../store';
import cilist from './CI-List';
export default {
  data(){
    return {
      videos : [{
        id: '',
        video_title: ''
      }],
      video_input : '',
      videoIndex: null,
    }
  },
  
  components: {
    'ci-list': cilist,
  },
  

  created(){
    this.getVideos();
  },

  methods: {
    getVideos(){
      let self = this;
      axios.get(self.$root.globalStore.apiUrl + '/getVideo',{
            auth: {
                username: 'standard',
                password: self.$root.globalStore.password,
            }
      })
      .then(function(response) {
        self.videos = response.data;
        console.log('videos geladen')
        
      })
      .catch(function(error){
        if(error.response){
          if (error.response.status == 401){
            store.data.wrongPass = false;
            self.$router.push('/')
          } else if (error.response.status == 404){
            console.log("keine Videos vorhanden")
          } else{
            console.log(error.response);
          }
        }
      })
      },

      addVideo(){
        let self = this;
        axios({
          method: 'post',
          url: self.$root.globalStore.apiUrl + '/createVideo',
          data: {
            title : this.video_input,
          },
          auth: {
            username: 'standard',
            password: self.$root.globalStore.password,
          }
        })
        .then(function(response){
          self.video_input = '';
          self.getVideos();
        })
        .catch(function(error){
          console.log(error);
        });
      },
      setVideoIndex(index){
        this.videoIndex = index;
        console.log(this.videoIndex);
      },

    setVideoId(id, title){
      store.data.currentVidId = id;
      store.data.currentVidTitle = title;
      this.$refs.cilist.getSchnitte();
    }
    },

  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue